import { render, staticRenderFns } from "./ProjectTasksHeader.vue?vue&type=template&id=415ba55a"
import script from "./ProjectTasksHeader.vue?vue&type=script&lang=ts"
export * from "./ProjectTasksHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports